/// <amd-module name="VSSUI/Components/MessageCard/MessageCard" />
import * as React from "react";

import { CustomCard } from "VSSUI/Card";
import { MessageBar } from "VSSUI/MessageBar";
import { css } from "VSSUI/Util";

import { IMessageCardProps } from "./MessageCard.Props";

export const MessageCard: React.FunctionComponent<IMessageCardProps> = props => {
    const { buttonProps, children, className, severity, iconProps, messageBarClassName, onDismiss } = props;

    return (
        <CustomCard className={css(className, "bolt-messagecard")}>
            <MessageBar
                buttonProps={buttonProps}
                children={children}
                className={messageBarClassName}
                iconProps={iconProps}
                onDismiss={onDismiss}
                severity={severity as any}
            />
        </CustomCard>
    );
};

MessageCard.displayName = "MessageCard";
